import { render, staticRenderFns } from "./ManualReportingBoxWide.vue?vue&type=template&id=a1f467a4&scoped=true&"
import script from "./ManualReportingBoxWide.vue?vue&type=script&lang=js&"
export * from "./ManualReportingBoxWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f467a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1f467a4')) {
      api.createRecord('a1f467a4', component.options)
    } else {
      api.reload('a1f467a4', component.options)
    }
    module.hot.accept("./ManualReportingBoxWide.vue?vue&type=template&id=a1f467a4&scoped=true&", function () {
      api.rerender('a1f467a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/reportoutage/ManualReportingBoxWide.vue"
export default component.exports